import { gql } from '@apollo/client'

const USER_ATTRIBUTES = gql`
  fragment userAttributes on User {
    id
    createdAt
    updatedAt

    firstName
    lastName
    email
    profilePicture {
      id
      url
    }
    userIdentity
  }
`

export const GET_USER = gql`
  query user_UI {
    user {
      ...userAttributes
    }
  }
  ${USER_ATTRIBUTES}
`

export const UPDATE_USER = gql`
  mutation updateUser_UI($input: UpdateUserInput!) {
    updateUser(input: $input) {
      ...userAttributes
    }
  }
  ${USER_ATTRIBUTES}
`

export const GET_WORKER_OR_ADMIN_USER = gql`
  query getWorkerOrAdminUser_UI {
    user {
      ...userAttributes
      worker {
        id
      }
      adminUser {
        id
      }
    }
  }
  ${USER_ATTRIBUTES}
`
